import { DESPESAS_EXTENSION, generalObjectBuilder, genericDelete, genericGetWithProcessor, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../services/api.service";
import TableView from "../Common/TableView";
import { DespesasTableConfigs } from "./Despesas.config";



export default function Despesas() {

    return (<div>
        <TableView
            title={"Despesas"}
            postEntity={genericPost(DESPESAS_EXTENSION)}
            editEntity={genericUpdate(DESPESAS_EXTENSION)}
            deleteEntity={genericDelete(DESPESAS_EXTENSION)}
            addButtonText={"Nova Despesa"}
            tableConfigs={DespesasTableConfigs}
            entityName={"Despesa"}
            dataBuildFunction={generalObjectBuilder(DespesasTableConfigs)}
            idProp={"id"}
            configMapKey={"despesas"}
            reroute={true}
        />
    </div>)

}

